import React, { useEffect }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Swal from 'sweetalert2'
import { useFormik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import { read, utils } from 'xlsx';
import { Button } from "@mui/material"
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import styled from "styled-components";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

const validationSchema = yup.object({
    users_list: yup
        .mixed()
        .nullable()
        .test('required', 'File is required', (value) => {
            return value !== null && value !== undefined;
        })
        .test('fileType', 'File type not supported!', (value) => {
            if (!value) return true; // Allow empty value (no file selected)
            const fileName = value.name;
            const fileExtension = fileName.split('.').pop();
            return fileExtension === 'xlsx' || fileExtension === 'xls';
        })
});

export const UploadExcel = ({show, setShow, handleClose, getList, ...rest}) => {

    const initialValues = {
        users_list: null,        
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    const handleSubmit = (values)=>{
        // setLoading(true);
        const file = values.users_list;
        console.log(file,'file')
        if(file){
            const reader = new FileReader();
            reader.onload = (event) => {
                const wb = read(event.target.result);
                const sheets = wb.SheetNames;
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                if (fileExtension === 'xlsx' || fileExtension === 'xls') {
                    if (sheets.length) {
                        const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                            axios.post(`api/users/multiplecreate`, {users: rows}).then(res => {
                            setShow(false);
                            if(res.data.success){
                                Swal.fire(res.data.message, '', 'success').then(result => {
                                    getList();  
                                })                
                            } 
                            else{
                                Swal.fire(res.data.message, '', 'error')
                            }
                        }).catch((error) => {
                            setShow(false);
                            Swal.fire(error.response.data.message, '', 'error')
                        });
                    
                    }
                } else {
                    setShow(false);
                    Swal.fire('File type not supported!', '', 'error')
                }
            }
            reader.readAsArrayBuffer(file);
        }
    
    }

    const handlePopupClose = () => {
        formik.resetForm();
        handleClose()
    }
    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>Upload Excel</Modal.Title>
            </Modal.Header>
            <form onSubmit={formik.handleSubmit}>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6">
                            <a href="./documents/userlist.xlsx" type="button" className="btn btn-outline-secondary">
                                <span className="bi bi-download me-1"> </span>
                                &nbsp; Download Sample File 
                            </a>
                        </div>
                         <div className="col-md-6">
                             <div className="">
                                 <Button className="w-100"
                                 type="button"
                                    component="label"
                                    role={undefined}
                                    variant="contained"
                                    tabIndex={-1}
                                    startIcon={<CloudUploadIcon />}>
                                        Upload file
                                    <VisuallyHiddenInput type="file" 
                                     name="users_list"
                                     accept={".csv, .xlsx, .xls"}
                                     onChange={(e) => {
                                       formik.setFieldValue('users_list', e.currentTarget.files[0]);
                                    }}
                                    onBlur={formik.handleBlur}
                                    />
                                </Button>
                                { formik.errors.users_list && (
                                    <div className="text-danger">{formik.errors.users_list}</div>
                                )}
                             </div>
                         </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                    <button type="submit" className="btn btn-primary">Upload</button>
                </Modal.Footer>
            </form>
        </Modal>        
    )
}